<template>
  <v-autocomplete
    hide-details="auto"
    :items="Table"
    :loading="loading"
    v-model="selectedTable"
    item-text="name"
    item-value="id"
    label="Table"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchTable"
  ></v-autocomplete>
</template>
<script>
import axios from "@/plugins/axios";
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Table: [],
    selectedTable: null,
    searchTable:null,
    loading:false
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedTable);
    },
    getTableByQuery(query = "") {
        
      this.loading = true;
        axios
        .get(`hms/tables`,{query: query,
          status: "active"})
        .then((res) => {
          this.Table = res.data.data
          this.loading = false;

        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedTable = null;
      },
      deep: true,
    },
    searchTable: {
      handler(val) {
        this.getTableByQuery(val);
      },
      deep: true,
    },
  },
  created(){
    this.getTableByQuery()
  }
};
</script>